import axios from "axios";
import merge from "lodash-es/merge";
import qs from "qs";
import {getAuthToken} from "../config/localStorage";
import {authTokenFailed} from "../store/features/authSlice";

export default function configureAxios(connect) {
  axios.interceptors.request.use(
    axiosRequestInterceptor(connect),
    axiosRequestErrorHandler(connect)
  );
  axios.interceptors.response.use(
    axiosResponseInterceptor(connect),
    axiosResponseErrorHandler(connect)
  );
}

export const axiosRequestInterceptor = () => (config) => {
  const authToken = getAuthToken();
  // Axios Configuration docs: https://github.com/axios/axios#request-config
  const defaults = {
    // all Axios requests default to IROH, unless the URL starts with http
    baseURL: `${window.CONFIG.apiBaseUri}/iroh`,
    headers: {
      Accept: "application/json",
      ["Content-Type"]: "application/json"
    },
    paramsSerializer: (params) =>
      qs.stringify(params, {
        // Serializes arrays in params in IROH's preferred format:
        // {params: {foo: [1, 2]}} => `?foo=1&foo=2` (not `?foo[]=1&foo[]=2`)
        arrayFormat: "repeat",
        // Reapplies default Axios encoding to all URL params
        // SOURCE: https://github.com/axios/axios/blob/main/lib/helpers/buildURL.js#L6
        encoder: function encode(val) {
          return encodeURIComponent(val)
            .replace(/%3A/gi, ":")
            .replace(/%24/g, "$")
            .replace(/%2C/gi, ",")
            .replace(/%20/g, "+")
            .replace(/%5B/gi, "[")
            .replace(/%5D/gi, "]");
        }
      }),
    timeout: window.CONFIG?.requestTimeout ?? 60_000
  };

  if (authToken) {
    defaults.headers.Authorization = `Bearer ${authToken}`;
  }

  return merge(defaults, config);
};

export const axiosRequestErrorHandler = () => (error) => Promise.reject(error);

export const axiosResponseInterceptor = () => (response) => response;

export const axiosResponseErrorHandler =
  ({dispatch}) =>
  (error) => {
    if (error.response) {
      // Request made and server responded
      if (!window.__SHELL__ && error.response.status === 401) {
        console.error(error);
        dispatch(authTokenFailed());
        return; // Return nothing. Don't update state. We're reloading.
      }
      return Promise.reject(error.response);
    }

    if (error.request) {
      // The request was made but no response was received
      return Promise.reject(error.request);
    }

    return Promise.reject(error);
  };
